import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import cloneDeep from 'lodash/cloneDeep';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { LogService } from 'src/app/core/services/log/log.service';
import { Mission } from 'src/app/shared/models/mission/mission';

@Component({
	selector: 'app-detail-meeting',
	templateUrl: './detail-meeting.component.html',
	styleUrls: ['./detail-meeting.component.scss']
})
export class DetailMeetingComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	synchronizedEvent: Mission = null;
	synchronizedEventModifiedInForm: Mission = null;
	confirmDeleteModalRef: BsModalRef;
	isDeletable: boolean;

	isFormReadOnly = true;

	// Pas réussi à faire fonctionner le form dans le meeting-form component, fonctionnement à revoir
	meetingDetailForm = new FormGroup({
		date: new FormControl(new Date(), [Validators.required]),
		readyTimeAsDate: new FormControl(new Date(), Validators.maxLength(2)),
		dueTimeAsDate: new FormControl(new Date(), Validators.maxLength(2)),
		notes: new FormControl('', Validators.maxLength(2048))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	// Pour l'affichage, on a besoin de date
	startDateWithHours: Date;
	endDateWithHours: Date;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.isDeletable = this.facade.dataStorageService.isPlanificatrice();
		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.meetingService.getMultipleEmployeeMissionById(id).subscribe({
			next: (meeting: Mission) => {
				this.synchronizedEvent = meeting;
				this.synchronizedEventModifiedInForm = cloneDeep(meeting);
				this.resetForm();
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/formations/list']);
	}

	deleteMeeting(): void {
		if (this.isDeletable) {
			this.facade.meetingService
				.deleteMeetingById(this.synchronizedEvent.missionRequest.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.goBack();
					}
				});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm() {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
		this.resetForm();
	}

	onSubmit() {
		this.isFormReadOnly = false;

		if (this.meetingDetailForm.valid) {
			this.isValidateButtonClicked.value = true;

			// Mise à jour du synchronized event (mission) avec les valeurs du formulaire
			this.synchronizedEventModifiedInForm.missionRequest.date =
				this.meetingDetailForm.value.date;
			this.synchronizedEventModifiedInForm.missionRequest.readyTime =
				this.meetingDetailForm.value.readyTimeAsDate.getHours() * 60 +
				this.meetingDetailForm.value.readyTimeAsDate.getMinutes();
			this.synchronizedEventModifiedInForm.missionRequest.dueTime =
				this.meetingDetailForm.value.dueTimeAsDate.getHours() * 60 +
				this.meetingDetailForm.value.dueTimeAsDate.getMinutes();

			this.synchronizedEventModifiedInForm.missionRequest.notes =
				this.meetingDetailForm.value.notes;

			this.facade.meetingService
				.updateMultipleEmployeeMission(this.synchronizedEventModifiedInForm)
				.subscribe({
					complete: () => {
						this.synchronizedEvent = cloneDeep(
							this.synchronizedEventModifiedInForm
						);
						this.stopEditForm();
					},
					error: (e) => {
						this.logger.error(e);
						this.stopEditForm();
					}
				});
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	resetForm() {
		this.meetingDetailForm.reset();

		const dateUtils = new DateUtils();
		this.startDateWithHours = dateUtils.getFullDateFromDateAndMinutes(
			this.synchronizedEvent.missionRequest.date,
			this.synchronizedEvent.missionRequest.readyTime
		);
		this.endDateWithHours = dateUtils.getFullDateFromDateAndMinutes(
			this.synchronizedEvent.missionRequest.date,
			this.synchronizedEvent.missionRequest.dueTime
		);

		this.meetingDetailForm.setValue({
			date: new Date(this.synchronizedEvent.missionRequest.date),
			readyTimeAsDate: this.startDateWithHours,
			dueTimeAsDate: this.endDateWithHours,
			notes: this.synchronizedEvent.missionRequest.notes
		});
		this.synchronizedEventModifiedInForm = cloneDeep(this.synchronizedEvent); // reset de l'objet modifié dans le formulaire
	}
}
